module.exports = __webpack_public_path__ + "components/star-rating/static/yellow/0.25-39f74bbd59b90e62ae89ed526ccc4dda.svg";